// extracted by mini-css-extract-plugin
module.exports = {"scrapersLogs":"ScrapersLogs_scrapersLogs__2hvql","header":"ScrapersLogs_header__Oi06V"};